/**
 * @fileoverview POST handler for the "/engagement/report_dashboards/update_tags" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { reportDashboardsUpdateTags } from "./constants";
import type { PutReportDashboardsUpdateTagsProps, ReportDashboardsUpdateTagsResult } from "./types";

export const putReportDashboardsUpdateTags = reactQueryMutationAdapter(
  reportDashboardsUpdateTags,
  (props: PutReportDashboardsUpdateTagsProps): Promise<ReportDashboardsUpdateTagsResult> => {
    return fetch("/engagement/report_dashboards/update_tags", "PUT", props);
  }
);
